import { useState } from 'react'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import useToast from 'hooks/useToast'

// The Chat page opens the thread named by ?cid= (its `DeepLink`).
export const chatPath = (cid) => `/chat?cid=${encodeURIComponent(cid)}`

// How to reach an account, beside its name: their Team Reclip thread on the
// Chat page, opened in a new tab so the page keeps its place, and their phone
// number to copy when they have one. `account` is anything carrying the
// admin's two contact fields, `team_reclip_cid` and `phone_number`: a moment
// card or a person. A guest has neither, and the icon is then disabled.
const ContactMenu = ({ account, size = 14 }) => {
  const toast = useToast()
  const [anchor, setAnchor] = useState(null)
  const cid = account.team_reclip_cid
  const phone = account.phone_number
  const close = () => setAnchor(null)
  const copyPhone = async () => {
    close()
    try {
      await navigator.clipboard.writeText(phone)
      toast({ message: 'Phone number copied.' })
    } catch (err) {
      toast({ message: err.message, severity: 'error' })
    }
  }
  return (
    <>
      <Tooltip
        placement="top"
        title={
          cid || phone
            ? 'Contact'
            : 'No chat thread or phone: a guest, or an account never onboarded'
        }
      >
        <span>
          <IconButton
            size="small"
            aria-label="contact"
            disabled={!cid && !phone}
            onClick={(event) => setAnchor(event.currentTarget)}
            sx={{ p: 0.25, ml: 0.25, verticalAlign: 'middle' }}
          >
            <ChatBubbleOutlineIcon sx={{ fontSize: size }} />
          </IconButton>
        </span>
      </Tooltip>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close}>
        {cid && (
          <MenuItem
            dense
            component={Link}
            to={chatPath(cid)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
          >
            <ListItemIcon>
              <OpenInNewIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Go to chat</ListItemText>
          </MenuItem>
        )}
        {phone && (
          <MenuItem dense onClick={copyPhone}>
            <ListItemIcon>
              <ContentCopyIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Copy phone number" secondary={phone} />
          </MenuItem>
        )}
      </Menu>
    </>
  )
}

export default ContactMenu
